import { AppBar, Typography, Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './auth';
import { FC } from 'react';

import ButtonOptions from './ButtonOptions';
import Logo from '@/assets/logo.svg';

const Header: FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  let icon = '';

  if (user?.role === 'admin') {
    icon = 'material-symbols:admin-panel-settings';
  } else if (user?.role === 'doctor') {
    icon = 'vaadin:doctor';
  } else if (user?.role === 'clinic-admin') {
    icon = 'eos-icons:admin';
  }

  return (
    <AppBar position="sticky" sx={{ backgroundColor: 'white', color: 'black' }}>
      <Box alignItems="center" display="flex" justifyContent="space-between" p={1}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
          <img width={42} src={Logo} alt="Logo" />
          <Typography
            component="div"
            fontSize={18}
            display="flex"
            flexDirection="column"
            lineHeight={1}
            ml={1}
            fontWeight="bold"
            color="#2c6291"
          >
            My&nbsp;
            <Typography lineHeight="inherit" fontSize="inherit" fontWeight="bold">
              Airway&nbsp;
            </Typography>
            <Typography lineHeight="inherit" fontSize="inherit" color="#7fc2e9">
              Exam
            </Typography>
          </Typography>
        </Link>
        {icon && (
          <ButtonOptions
            icon={icon}
            iconProps={{ height: 40, color: 'black' }}
            options={[{ label: 'Logout', value: 'option1' }]}
            onClick={(option) => {
              if (option.value === 'option1') {
                navigate('/logout', { replace: true });
              }
            }}
          />
        )}
      </Box>
    </AppBar>
  );
};

export default Header;
